class NumberHelper {
    static addCommas(input) {

        var parts = input.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    static formatOutput(input) {
        let value = parseFloat(input);
        let output = value.toFixed();
        if(value > 0 && value < 1) {
            output = parseFloat(value.toFixed(2));
        }

        output = output.length > 10 ? parseInt(output, 10).toExponential(2) : NumberHelper.addCommas(output);

        return output;
    }
}

export default NumberHelper;


/** WEBPACK FOOTER **
 ** ./src/utils/NumberHelper.js
 **/